export function ajaxFetchCall(url, reqObj) {
    // if (localStorage[url]) {
    //     return JSON.parse(localStorage[url]);
    // }

    let token = "";
    if (localStorage["token"]) {
        token = JSON.parse(localStorage["token"]);
    }
    const defaultObj = {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: token,
        },
    };

    const ajaxObj = { ...defaultObj, ...reqObj };

    return fetch(url, ajaxObj)
        .then(async (response) => {

            if (response.ok) {
                if (response.status === 204) {
                    return Promise.resolve(null);
                }
                let r = await response.text();
                try {
                    let j = JSON.parse(r);
                    // localStorage[url] = JSON.stringify(j);

                    return Promise.resolve(j);
                } catch (err) {
                    return Promise.resolve(r);
                }
            } else {
                return Promise.reject(response);
            }
        })
        .then((json) => {
            if (json && json.error) {
                console.error("Error:", json.error, "URL:", url, "request object:", JSON.stringify(ajaxObj));
                return Promise.reject(json.error);
            } else return Promise.resolve(json);
        })
        .catch((err) => Promise.reject(err));
}
